var store = {
  state: false,
  uploadReinigungsnachweis: false,
  countReinigungsnachweis: 0,
  uploadTemperatur: false,
  countTemperatur: 0,
  needUpload() {
    this.resetUpload();
    if (localStorage.getItem('checklistQS' + 1)) {
      this.uploadReinigungsnachweis = true;
      this.countReinigungsnachweis = JSON.parse(localStorage.getItem('checklistQS' + 1)).length;
    } else {
      this.uploadReinigungsnachweis = false;
    }
    for (let i = 1; i <= 5; i++) {
      if (localStorage.getItem('mpoints' + i)) {
        this.countTemperatur += JSON.parse(localStorage.getItem('mpoints' + i)).length;
      }
    }
    this.countTemperatur === 0 ? this.uploadTemperatur = false : this.uploadTemperatur = true;
  },
  resetUpload() {
    this.uploadReinigungsnachweis = false;
    this.uploadTemperatur         = false;
    this.countReinigungsnachweis  = 0;
    this.countTemperatur          = 0;
  }
}

export default store;